<script>
import BookingSummary from '@components/booking-summary'
import { confirmationPageTracking, terminateTracking } from '@src/tracking'
import { mapGetters, mapMutations } from 'vuex'

export default {
  page() {
    return {
      title: `${this.property.name} - Booking Confirmation`,
      meta: [{ name: 'description', content: 'Booking Confirmation' }],
    }
  },
  components: { BookingSummary },
  props: {
    property: { type: Object, required: true },
  },
  computed: {
    ...mapGetters('cart', ['trackingParams']),
  },
  mounted() {
    if (process.env.NODE_ENV === 'production') {
      confirmationPageTracking(
        this.trackingParams,
        this.property,
        this.$route.params.bookingId
      )
    }

    this.setAlert({
      message:
        'Thank you for your booking! Your booking has been confirm. We are looking forward for your visit.',
    })
  },
  beforeDestroy() {
    if (process.env.NODE_ENV === 'production') {
      terminateTracking()
    }
  },
  methods: {
    ...mapMutations('app', { setAlert: 'SET_ALERT' }),
    print() {
      window.print()
    },
  },
}
</script>

<template>
  <section class="mt-6">
    <div class="container container-page mx-auto px-6">
      <BaseAlert />

      <BaseBox class="mb-6">
        <span class="font-medium">
          Booking ID: {{ $route.params.bookingId }}
        </span>
      </BaseBox>

      <BaseBox title="Booking Confirmation" class="mb-6 print:hidden">
        <div class="text-sm">
          <p class="mb-3">
            Please print this acknowledgement and present it to the property
            reception on arrivel. A receipt will be emailed to you at the
            address entered during the booking process.
          </p>
          <button class="btn btn-gold mr-3" @click="print">
            <i class="fas fa-print"></i>
            Print
          </button>
          <BaseLink :to="{ name: 'property-landing' }" class="btn btn-gold">
            Back to hotel website
          </BaseLink>
        </div>
      </BaseBox>

      <BookingSummary
        class="mb-6"
        :maximum-infant-age="property.policy.maximumInfantAge"
        disable-edit
      />

      <BaseBox title="Terms Conditions and Cancellation Policies" class="mb-6">
        <div class="text-sm">
          <div class="mb-6">
            <h4 class="mb-1 font-medium">Terms and Conditions</h4>
            <!-- eslint-disable-next-line -->
            <p v-html="property.policy.termsAndConditions"></p>
          </div>
          <div class="mb-3">
            <h4 class="mb-1 font-medium">Cancellation Policies</h4>
            <div v-for="item in trackingParams.items" :key="item.name">
              <h5>{{ item.name }}</h5>
              <p>{{ item.cancellation }}</p>
            </div>
          </div>
        </div>
      </BaseBox>
    </div>
  </section>
</template>
